import { render, staticRenderFns } from "./choosePop.vue?vue&type=template&id=505fa2e7&scoped=true"
import script from "./choosePop.vue?vue&type=script&lang=js"
export * from "./choosePop.vue?vue&type=script&lang=js"
import style0 from "./choosePop.vue?vue&type=style&index=0&id=505fa2e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505fa2e7",
  null
  
)

export default component.exports